module.exports = __webpack_public_path__ + "img/solu_4.96828e41.png";